

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://e851506caba54d6fa11e9a953b4a5d51@sentry-next.wixpress.com/21551", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/689798b9954668/packages/communities-blog-ooi/src/components/MyPosts/Widget/index.tsx';
    import createController from '/home/builduser/work/689798b9954668/packages/communities-blog-ooi/src/components/MyPosts/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/689798b9954668/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'MyPosts';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://e851506caba54d6fa11e9a953b4a5d51@sentry-next.wixpress.com/21551',
      id: 'e851506caba54d6fa11e9a953b4a5d51',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas-feds',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/689798b9954668/packages/communities-blog-ooi/src/components/MyPosts/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/689798b9954668/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"messages.post-changes-not-published":"You have post changes that aren't published yet.","messages.commenting-enabled":"Readers can now comment on this post!","like-button.aria-label.unlike":"Unlike post","post-actions.duplicate-post":"Duplicate Post","share-post-modal.share-post":"Share Post","no-submissions.content":"Once you create and submit a post, it'll wait here for review.","messages.category-title-required":"Add a <strong>name</strong> to go ahead and create.","like-button.comment-is-liked":"Comment marked as liked","no-publications.title":"No posts published","pagination.first-page":"First page","messages.draft-deleted":"Your draft has been deleted.","messages.post-moved-to-trash":"Post moved to trash.","post-actions.unpin-post":"Unpin post","messages.post-changes-discarded":"Post changes have been discarded.","ratings-display.no-ratings":"No ratings yet","messages.category-fields-required":"To publish add a <strong>title</strong> & <strong>a few words</strong>.","post-actions.enable-commenting":"Turn on commenting","share-link.copied":"Link copied.","messages.category-unsubscribed":"You are <strong>no longer following</strong> this category!","messages.user-unsubscribed":"You are <strong>no longer following</strong> this member!","messages.post-unsubscribed":"You are <strong>no longer following</strong> this post!","messages.post-submitted-for-moderation":"Post submitted for review.","messages.draft-moved-to-trash":"Draft moved to trash.","ratings-display.count":"{count, plural, =0 {No ratings} one {# Rating} other {# Ratings}}","messages.settings-saved":"Your blog settings have been saved.","post-actions.pin-post":"Pin to feed","pagination.next-page":"Next page","delete-confirmation.cancel":"Cancel","counter.count":"{count, number}","ratings-display.rating-aria-label":"Rated {rating, plural, one {#} other {#}} out of 5 stars.","messages.post-fields-required":"To publish add a title & a few words.","messages.profile-image-uploading":"Please wait profile <strong>image</strong> is uploading.","messages.profile-cover-uploading":"Please wait profile <strong>cover</strong> is uploading.","messages.post-title-required":"Add a title to go ahead and publish.","messages.profile-update-failed":"Failed to update profile","post-list-item.aria-label.pinned-post":"Pinned post","messages.user-subscribed":"You are now <strong>following</strong> this member!","messages.post-published":"Great, post published!","view-count.label":"{count, plural, one {# view} other {# views}}","messages.post-moved":"Post successfully moved.","messages.comment-updated":"Comment <strong>Updated</strong>.","messages.user-unblocked":"Member successfully <strong>unblocked</strong>.","messages.draft-duplicated":"Success! Draft duplicated.","time-to-read.short-label":"{minutes} min","messages.profile-updated":"Your profile's updated.","post-actions.print":"Print Post","share-post-modal.close-button-aria-label":"Close","like-button.comment-is-unliked":"Comment not marked as liked","messages.category-deleted":"Category deleted.","messages.user-demoted-writer":"This member is no longer a writer of your blog","messages.post-delete-another-writer-editing-error":"You can't delete this post right now because someone else is working on it. Try again later.","like-button.total-likes":"like.","pagination.page":"Page {page, number}","like-button.is-unliked":"Post not marked as liked","messages.post-deleted":"Post deleted.","messages.post-duplicated":"Success! Post duplicated.","messages.file-upload-limited":"File upload limit reached.","messages.file-upload-failure":"Your file didn’t upload. Check your internet connection and try again.","post-actions.follow":"Follow post","messages.profile-name-required":"Add a your <strong>name</strong> and continue.","post-actions.edit-post":"Edit post","like-button.is-liked":"Post marked as liked","aria-label.authors-picture":"Writer","messages.post-unpinned":"Post unpinned from feed.","no-publications.content":"Write a post and publish it for your readers.","messages.post-updated":"Your post has been updated.","messages.logo-saved":"You updated your logo. ","more-button.more-actions":"More actions","page-title":"Blog Posts","messages.profile-unknown-error":"Unknown error please contact Support.","messages.commenting-disabled":"Readers can no longer comment on this post.","tabs.publications":"Published","no-submissions.title":"No posts pending review","messages.post-content-required":"Add a post to go ahead and publish.","tabs.drafts":"Drafts","messages.technical-issue":"We ran into a technical issue. Please try again.","post-actions.share-post":"Share post","messages.file-too-big":"That file is too big. Files can be up to 500MB.","few-seconds-ago":"a few seconds ago","pagination.last-page":"Last page","post-actions.disable-commenting":"Turn off commenting","delete-post-modal.will-detele-comments":"This post’s views, likes and comments will be deleted.","messages.user-promoted-writer":"This member is now a writer of your blog","delete-post-modal.delete-post":"Move to Trash?","messages.category-subscribed":"You are now <strong>following</strong> this category!","messages.category-created":"Category created.","no-drafts.title":"No post drafts","pro-gallery.parent-container-aria-label":"Post list. Select a post to read.","messages.post-updated-in-moderation":"Post updated and resubmitted for review.","delete-post-modal.confirm-action":"Move to Trash","messages.post-restored":"Post restored and moved to drafts.","messages.download-will-begin-shortly":"Download starting. If nothing happens, tap again.","messages.post-pinned":"Post pinned to feed.","no-drafts.content":"Keep your posts in drafts until you’re ready to publish.","like-button.total-likes_plural":"likes.","messages.post-reverted-to-draft":"Post moved to drafts.","post-actions.unfollow":"Unfollow post","pagination.previous-page":"Previous page","post-actions.duplicate-post-copy-of":"Copy of","messages.comment-deleted":"Comment Deleted.","like-button.aria-label.like":"Like post","comment-count.label":"{count, plural, one {# comment} other {# comments}}","messages.user-blocked":"Member successfully <strong>blocked</strong>.","create-post-button.label":"Create a Post","delete-confirmation.delete":"Delete","messages.post-subscribed":"You are now <strong>following</strong> this post!","time-to-read.label":"{minutes} min read","messages.post-category-changed":"Post category successfully <strong>changed</strong>.","tabs.submissions":"Pending Review","post-actions.delete-post":"Delete post"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "e5a2773b-0e6b-4cbb-a012-3b4a69e92046";
    var localeDistPath = 'components/MyPosts/locales/widget';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/689798b9954668/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
